import React from 'react';

export default () => (
  <svg className="icon-active icon-dmtrix" width="16" height="16" viewBox="0 0 16 16">
    <path d="M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
    <path d="M7 7V4h2v3h3v2H9v3H7V9H4V7h3z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/PlusSvg.js